import {
  Brain, ClipboardList, CalendarDays, Pin, Leaf, Mountain, Flag, CircleParking, Timer, Lightbulb, Heart, MapPin,
  CloudDownload, Sprout, Target, Hourglass, CheckCircle2, CheckSquare, BarChart3, Clock, Sparkles, Gauge, Zap, Star,
  Binoculars, Mailbox, Cloud, Flower2, Route, Fish, ListChecks,
} from 'lucide-react';

export const ICONS = {
  Brain, ClipboardList, CalendarDays, Pin, Leaf, Mountain, Flag, CircleParking, Timer, Lightbulb, Heart, MapPin,
  CloudDownload, Sprout, Target, Hourglass, CheckCircle2, CheckSquare, BarChart3, Clock, Sparkles, Gauge, Zap, Star,
  Binoculars, Mailbox, Cloud, Flower2, Route, Fish, ListChecks,
};

// Soft worksheet colours (box background, ink for numbers/icons, header pill)
export const TONES = {
  green: { bg: '#eef2e8', ink: '#3f5e2f', pill: '#dfe8d4' },
  blue: { bg: '#e8f1f5', ink: '#1f5068', pill: '#d3e5ee' },
  orange: { bg: '#f8efe6', ink: '#a2521d', pill: '#f1dcc8' },
  plum: { bg: '#f6f0f5', ink: '#6b3a5e', pill: '#eadbe6' },
  white: { bg: '#ffffff', ink: '#6b3a5e', pill: '#f3ecf2' },
};

export const SheetIcon = ({ name, color, size = 40 }) => {
  const C = name && ICONS[name];
  return C ? <C size={size} strokeWidth={1.6} style={{ color }} aria-hidden /> : null;
};
